// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3O9Dk","inputWrap":"Table_inputWrap__2S5zk","col":"Table_col__1jUhN","bmiTooltip":"Table_bmiTooltip__22_ZU"};